/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
import 'alpinejs'
window.MultiSelect = require('./includes/custom-select').default;
window.moment = require('moment');
window._ = require('lodash');
window.mediumZoom = require('medium-zoom').default;
window.toastr = require('toastr');

require('../bootstrap');
require('../plugins');
require('select2');
require('jquery-validation');
require('./includes/juxtapose')
require('./rio');
require('bootstrap-star-rating/js/star-rating');
require('bootstrap-star-rating/themes/krajee-fas/theme');